import React from 'react';
import PropTypes from 'prop-types';
import {
  ListChecks, EnvelopeSimple, PhoneCall, HourglassSimple,
  CalendarCheck, CheckCircle, XCircle,
} from '@phosphor-icons/react';
import './statsDashboard.scss';

const STATUS_CARDS = [
  {
    label: 'Total',
    statusKey: null,
    filterValue: '',
    colorKey: 'total',
    icon: <ListChecks size={16} weight="bold" />,
    countFrom: 'total',
  },
  {
    label: 'Received',
    statusKey: 'Received',
    filterValue: 'Received',
    colorKey: 'received',
    icon: <EnvelopeSimple size={16} weight="bold" />,
  },
  {
    label: 'Contacting',
    statusKey: 'Contacting Patient',
    filterValue: 'Contacting Patient',
    colorKey: 'contacting',
    icon: <PhoneCall size={16} weight="bold" />,
  },
  {
    label: 'Waiting on Info',
    statusKey: 'Waiting on Info',
    filterValue: 'Waiting on Info',
    colorKey: 'waiting',
    icon: <HourglassSimple size={16} weight="bold" />,
  },
  {
    label: 'Scheduled',
    statusKey: 'Scheduled',
    filterValue: 'Scheduled',
    colorKey: 'scheduled',
    icon: <CalendarCheck size={16} weight="bold" />,
  },
  {
    label: 'Completed',
    statusKey: 'Seen/Visit Held',
    filterValue: 'Seen/Visit Held',
    colorKey: 'completed',
    icon: <CheckCircle size={16} weight="bold" />,
  },
  {
    label: 'Canceled',
    statusKey: 'Canceled/Declined',
    filterValue: 'Canceled/Declined',
    colorKey: 'canceled',
    icon: <XCircle size={16} weight="bold" />,
  },
];

const StatsDashboard = ({ stats, activeFilter, onFilterClick }) => {
  const statusCounts = stats.status_counts || {};
  const activeFilters = Array.isArray(activeFilter) ? activeFilter : [];

  return (
    <div className="stats-dashboard">
      {STATUS_CARDS.map((card) => {
        const value = card.countFrom === 'total'
          ? stats.total
          : (statusCounts[card.statusKey] || 0);
        const isActive = card.filterValue
          ? activeFilters.includes(card.filterValue)
          : activeFilters.length === 0;

        return (
          <button
            key={card.colorKey}
            type="button"
            className={`stats-dashboard__card stats-dashboard__card--${card.colorKey} ${isActive ? 'stats-dashboard__card--active' : ''}`}
            onClick={() => onFilterClick && onFilterClick(card.filterValue)}
          >
            <span className="stats-dashboard__icon-circle">{card.icon}</span>
            <span className="stats-dashboard__text">
              <span className="stats-dashboard__value">{value}</span>
              <span className="stats-dashboard__label">{card.label}</span>
            </span>
          </button>
        );
      })}
    </div>
  );
};

StatsDashboard.propTypes = {
  stats: PropTypes.shape({
    total: PropTypes.number.isRequired,
    pending: PropTypes.number.isRequired,
    scheduled: PropTypes.number.isRequired,
    completed: PropTypes.number.isRequired,
    status_counts: PropTypes.object,
  }).isRequired,
  activeFilter: PropTypes.arrayOf(PropTypes.string),
  onFilterClick: PropTypes.func,
};

StatsDashboard.defaultProps = {
  activeFilter: [],
  onFilterClick: null,
};

export default StatsDashboard;
